// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"541":"38edc7bb","787":"8c24787a"}[chunkId] + ".chunk.js";
};